import { packNetAxios } from "@/lib/api-client";
import { baseRoutes } from "@/api/base-routes";

const baseUrl: string = `${baseRoutes.pl1}/api/v1/machines`;

export async function deletePl1Machine(id: string): Promise<boolean> {
	const response = await packNetAxios.delete(`${baseUrl}/${id}`);
	return response.status === 200;
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.pl1}/api/v1/version`);
	return response.data;
}
